import { TFunction } from 'i18next';

interface ITagWithName {
  name: string;
}

interface IAddresseeResult {
  text: string;
  extraTags: string[] | null;
}

const MAX_VISIBLE_TAGS = 2;
const MIN_HIDDEN_TAGS_FOR_PLUS = 2;

export const formatAddresseesList = (tags: ITagWithName[], t: TFunction): IAddresseeResult => {
  if (tags.length === 0) {
    return { text: t('GLOBAL_NEWS'), extraTags: null };
  }

  const tagNames = tags.map(tag => tag.name);
  const totalTags = tagNames.length;
  const hiddenCount = totalTags - MAX_VISIBLE_TAGS;

  if (totalTags <= MAX_VISIBLE_TAGS || hiddenCount < MIN_HIDDEN_TAGS_FOR_PLUS) {
    return {
      text: tagNames.join(' · '),
      extraTags: null
    };
  }

  const visibleTags = tagNames.slice(0, MAX_VISIBLE_TAGS);
  const extraTags = tagNames.slice(MAX_VISIBLE_TAGS);
  const plusText = t('ADDRESSEE_MORE', { count: hiddenCount });

  return {
    text: `${visibleTags.join(' · ')} · ${plusText}`,
    extraTags
  };
};
